import React, { useEffect, useState } from 'react'
import dayjs from 'dayjs'
import classNames from 'classnames'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'

import { CircularLoader } from '@st-operations/uikit/src/v2'

import { getEntityLogs } from '_services/changelogs'

import { TITLE_MAP, handleArray, makeLink } from './helpers'

import './styles.scss'

const LogEntry = ({ entry, titleMap, selectedId }) => {
  const { createdBy = {}, createdAt, type, data } = entry

  return (
    <div className={classNames('diff-item', { 'diff-item--selected': entry._id === selectedId })}>
      <div className="diff-item__meta">
        <p title="MM/DD/YYYY HH:mm">{dayjs(createdAt).format('MM/DD/YYYY HH:mm')}</p>
        <p>{createdBy.email}</p>
        <p>{type}</p>
      </div>
      <div className="diff-item__separator">
        <span></span>
      </div>
      <div className="diff-item__changes">
        <Choose>
          <When condition={data && JSON.stringify(data) !== '{}'}>
            {Object.entries(data).map(([key, content]) => (
              <div key={key}>
                <p title={key}>{titleMap[key] ?? key}</p>
                <div className="diff-item__removed">{handleArray(content.at(0))}</div>
                <div className="diff-item__added">{handleArray(content.at(1))}</div>
              </div>
            ))}
          </When>
          <Otherwise>
            <span className="diff-item__no-data">no data</span>
          </Otherwise>
        </Choose>
      </div>
    </div>
  )
}

const DiffModal = ({ details }) => {
  const { collection, id, name = '', _id } = details
  const [logs, setLogs] = useState(null)

  const link = makeLink(collection, id)

  useEffect(() => {
    getEntityLogs({ collection, id }).then(({ items }) => setLogs(items))
  }, [])

  return (
    <div className="diff-view">
      <header>
        <h1>
          <Choose>
            <When condition={link}>
              Changelog:{' '}
              <Link to={link} target="_blank" rel="noopener noreferrer" title="Open Entity">
                {name}
              </Link>
            </When>
            <Otherwise>Changelog: {name}</Otherwise>
          </Choose>
        </h1>
        <p>Collection: {collection}</p>
      </header>
      <main>
        <Choose>
          <When condition={!logs}>
            <CircularLoader style={{ margin: '0 auto' }} />
          </When>
          <Otherwise>
            {logs.map((entry, i) => (
              <LogEntry key={i} entry={entry} titleMap={TITLE_MAP[collection]} selectedId={_id} />
            ))}
          </Otherwise>
        </Choose>
      </main>
    </div>
  )
}

export default DiffModal
